import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
// convert flat folder array to a { folder, subfolders }[] array based on parentId attr
export const convertToFoldersWithSubfolders = (folders)=>{
    return folders// leave only top level folders
    .filter(isTopLevelFolder)// attach subfolders
    .map((folder)=>_object_spread_props(_object_spread({}, folder), {
            subfolders: folder.hasSubfolders === false // little perf improvement - don't filter long lists if not needed
             ? [] : folders.filter((potentialSubfolder)=>potentialSubfolder.parentId === folder.folderId)
        }));
};
export const isTopLevelFolder = (folder)=>!folder.parentId;
export const filterTopLevelFolders = (folders)=>folders.filter(isTopLevelFolder);
